import React, { FunctionComponent } from "react";

import { partTypePackage } from "../../../constants/partTypes";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { getDefaultQuantity } from "../../PriceSelect/getDefaultQuantity";
import { usePriceSelectState } from "../../PriceSelect/usePriceSelectState";
import { usePricing } from "../../PriceSelect/usePricing";
import { Image } from "../Common/Image";
import { Actions } from "../Common/LeadForm/Actions";
import { PricingNote } from "../Common/PricingNote";
import { PackageDescription } from "./PackageDescription";
import { PackageSpec } from "./PackageSpec";
import { PackageWarning } from "./PackageWarning";

type PackageDetailsProps = {
  part: PackagePartItem | null;
};

export const PackageDetails: FunctionComponent<PackageDetailsProps> = ({
  part,
}) => {
  const [priceEntries, setPriceEntries] = usePriceSelectState([]);

  usePricing({
    defaultQuantity: getDefaultQuantity({
      isStaggered: false,
      orderItem: null,
      part,
    }),
    isStaggered: false,
    onReady: setPriceEntries,
    part,
  });

  return (
    <div className="grid md:grid-cols-3 gap-4">
      <main className="flex flex-col gap-4 md:col-span-2">
        <Image part={part} />
        <PackageSpec part={part} />
        <PackageDescription part={part} />
        <PackageWarning part={part} />
        <PricingNote partType={partTypePackage} />
      </main>
      <aside className="flex flex-col gap-4">
        <Actions
          isStaggered={false}
          part={part}
          priceEntries={priceEntries}
          setPriceEntries={setPriceEntries}
        />
      </aside>
    </div>
  );
};
